export default __webpack_public_path__ + "static/media/Arii.ec8d204a.webp";